import { useCallback, useRef, useState } from 'react'
import { reilmAPI } from '../../../services/apiClient'

// Add Scenario's template list, fetched on every open; the last list stays while it runs
// (../README.md, "Scenarios").
export default function useTemplateOptions() {
  const [templates, setTemplates] = useState(null)
  const [loadFailed, setLoadFailed] = useState(false)
  const requestRef = useRef(0)
  const answeredRef = useRef(0)

  const load = useCallback(() => {
    const request = ++requestRef.current
    setLoadFailed(false)
    reilmAPI
      .getFlipTemplates()
      .then(({ data }) => {
        // An older answer still counts until a newer one lands, so a failed retry cannot hide it.
        if (request < answeredRef.current) return
        answeredRef.current = request
        setTemplates(data?.data?.flipTemplate ?? [])
        setLoadFailed(false)
      })
      .catch(() => {
        if (request === requestRef.current) setLoadFailed(true)
      })
  }, [])

  return { templates, loadFailed, load }
}
